<template>
  <div>
    <div class="input" @click.stop>
      <el-input v-model="searchCompany" placeholder="输入公司监控名称" @input="selectCompanyName" @focus="companyNameInputFacus"></el-input>
      <div class="suggestion" v-if="searchCompany && recommendWordList.length > 0 && isShowList">
        <ul class="suggestion-list">
          <li class="suggestion-item" v-for="item in recommendWordList" :key="item.index" @click="onSuggestionItemClick(item)">
            <span class="item-value">{{item}}</span>
          </li>
        </ul>
      </div>
    </div>
    <el-button @click="onAddCompanyClick">添加</el-button>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      searchCompany: '',
      recommendWordList: [],
      isShowList: false
    };
  },
  props: {
    
  },
  methods: {
    companyNameInputFacus() {
      this.isShowList = true;
    },
    companyNameInputBlur() {
      this.isShowList = false;
    },
    selectCompanyName() {
      QuestionQuery.searchTermsRecommend(this.searchCompany).then(res => {
        this.recommendWordList = res.recommendWord;
      });
    },
    onSuggestionItemClick(res) {
      this.$emit('selectCompany', res);
      this.recommendWordList = [];
      this.searchCompany = '';
    },
    onAddCompanyClick() {
      this.$emit('selectCompany', this.recommendWordList[0]);
      this.recommendWordList = [];
      this.searchCompany = '';
    }
  },
  watch: {
    
  },
  mounted() {
    document.addEventListener('click', this.companyNameInputBlur);
    this.username = authService.getLoggedUserName();
  },
  beforeDestroy() {
    // un-register events
    if (this.isShowList) {
      this.companyNameInputBlur();
    }
    document.removeEventListener('click', this.companyNameInputBlur);
  }
};
</script>

<style lang="scss" scoped>
.input {
  display: inline-block;
  position: relative;
  .suggestion {
    position: absolute;
    width: 236px;
    background-color: #17171b;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    z-index: 1000;
    .suggestion-list {
      margin: 4px 0;
      list-style: none;
      padding: 0;
      .suggestion-item {
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        &:hover {
          background-color: #222227;
        }
        .item-value {
          padding-left: 12px;
          display: inline-block;
          max-width: 226px;
          vertical-align: middle;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
  .el-input {
    display: inline-block;
    height: 26px;
    width: 192px;
  }
  .el-button {
    width: 44px;
    height: 26px;
    padding: 0;
    border: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    color: #ffffff;
    background-color: #605e61;
    &:hover {
      color: #ffffff;
      background-color: #3e9dcc;
    }
    &:focus {
      color: #ffffff;
      background-color: #2183b3;
    }
  }
  .el-input /deep/.el-input__inner {
    height: 26px;
    border: solid 1px #585659;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #27252a !important;
    color: #ffffff;
  }
</style>
